export default __webpack_public_path__ + "84343e39d467fbce5c846c2046933268.svg";